var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcValeWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.667,11H30.333V24H8.667ZM35.75,17.5A3.25,3.25,0,0,0,39,20.75v6.5a3.25,3.25,0,0,1-3.25,3.25H3.25A3.25,3.25,0,0,1,0,27.25v-6.5a3.25,3.25,0,1,0,0-6.5V7.75A3.25,3.25,0,0,1,3.25,4.5h32.5A3.25,3.25,0,0,1,39,7.75v6.5A3.25,3.25,0,0,0,35.75,17.5ZM32.5,10.458a1.625,1.625,0,0,0-1.625-1.625H8.125A1.625,1.625,0,0,0,6.5,10.458V24.542a1.625,1.625,0,0,0,1.625,1.625h22.75A1.625,1.625,0,0,0,32.5,24.542Z",
    transform: "translate(0 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcValeWhite);
export default __webpack_public_path__ + "static/media/ic_vale_white.9f4c92cd48a39f7b96ae293cdf4b7f93.svg";
export { ForwardRef as ReactComponent };